import { CheckIcon } from '@phosphor-icons/react';

import { formatDate } from '../../../../../utils/date';
import { nullthrows } from '../../../../../utils/invariant';
import { decimateAndFormatNumber } from '../../../../../utils/number';
import { useInvoices } from '../../../../sale/models';
import { useCreateIncassoCtx } from './context';
import { Invoice } from './types';
import classNames from '@utils/classnames';
import { DelayedSpinner } from '../../../../../components/Spinner';

export interface Props {
  searchValue: string;
}

export const InvoiceSelect: React.FC<Props> = (props) => {
  const { searchValue } = props;
  const { state, dispatch } = useCreateIncassoCtx();
  const customer = nullthrows(state.selectedCustomer, 'No customer selected');
  const { data, isLoading } = useInvoices({
    customerId: customer.id,
    search: searchValue || undefined,
    noIncasso: true,
  });

  if (isLoading) {
    return <DelayedSpinner size={8} />;
  }

  // The REST list item is structurally identical to the GraphQL Invoice the
  // reducer stores (only `status` differs nominally: enum vs string union).
  const invoices = (data ?? []) as unknown as Invoice[];

  return (
    <div className="grid gap-4 lg:grid-cols-2 xl:grid-cols-3">
      {!invoices.length && <div>Geen verkopen gevonden</div>}

      {invoices.map((i) => {
        const isSelected = state.selectedInvoices.some((v) => v.id === i.id);

        return (
          <div
            key={i.id}
            className={classNames('card p-4', {
              'subtle-selected-card': isSelected,
            })}
            data-clickable="true"
            onClick={() => {
              dispatch({
                type: 'SELECT_INVOICE',
                invoice: i,
              });
            }}
          >
            <div className="flex justify-between">
              <div className="card-heading-text">{i.invoiceNumber}</div>
              <div className="flex justify-start gap-2">
                <div className="card-subtle-text">{formatDate(i.date)}</div>
                <div>{isSelected ? <CheckIcon className="h-6 w-6 text-brand" /> : null}</div>
              </div>
            </div>

            <div className="mt-4">{`Verzonden op: ${i.sentAt ? formatDate(i.sentAt) : '-'}`}</div>
            <div>{`Betaald op: ${i.paidAt ? formatDate(i.paidAt) : '-'}`}</div>
            <div>{`Totaal: € ${decimateAndFormatNumber(i.totalInclVat, 2, {
              decimalSeperator: ',',
            })}`}</div>
          </div>
        );
      })}
    </div>
  );
};
